import ms from 'ms';
import lastTimestampFromPricesMap from './last-timestamp-from-prices-map.js';
const STEP_MS = {
    hour: ms('1h'),
    minute: ms('1m'),
};
const cropHistory = ({ history, limit, step, }) => {
    const stepMs = STEP_MS[step];
    const lastCachedTime = lastTimestampFromPricesMap(history);
    if (!lastCachedTime)
        return history;
    const limitedTime = lastCachedTime - stepMs * limit;
    const result = new Map();
    for (const [key, value] of history.entries()) {
        if (key > limitedTime) {
            result.set(key, value);
        }
    }
    return result;
};
export default cropHistory;
